import React, { useContext, useEffect, useState } from 'react';
import { Layout as BaseLayout } from 'antd';
import Sidebar from './Sidebar';
import { Outlet } from 'react-router-dom';
import './style.css';
import { Navigate } from 'react-router-dom';
import { useIsLoggedIn } from '../store/auth';
import LoadingLayout from './LoadingLayout';
import { SessionExpiredModalContext } from '~/providers/SessionExpiredModalProvider';
import { setOpenModalFn } from '~/http/modal';

const useInitLayout = () => {
  const { openModalFn } = useContext(SessionExpiredModalContext);
  useEffect(() => {
    setOpenModalFn(openModalFn);
    return () => {
      setOpenModalFn(null);
    };
  }, []);
};

const Layout = () => {
  useInitLayout();
  const [isLoggedIn, setIsLoggedIn] = useState<boolean | null>(null);
  const checkIsLoggedIn = useIsLoggedIn();

  useEffect(() => {
    checkIsLoggedIn().then((val) => {
      if (val) {
        setIsLoggedIn(true);
      } else {
        setIsLoggedIn(false);
      }
    });
  }, []);

  if (isLoggedIn == null) {
    return <LoadingLayout />;
  } else if (!isLoggedIn) {
    return <Navigate to={'/auth/login'} />;
  } else {
    return (
      <BaseLayout style={{ minHeight: '100vh' }}>
        <Sidebar />
        <div className="bg-white w-full">
          <Outlet />
        </div>
      </BaseLayout>
    );
  }
};

export default Layout;
